module.exports = __webpack_public_path__ + "static/media/rentalcars.4b2dcd20.svg";